import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { UserRole } from '../models/user-role.types';

@Injectable({
  providedIn: 'root',
})
export class AdminGuardService {
  private router = inject(Router);
  private authService = inject(AuthService);
  private readonly user = this.authService.currentUser;

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const user = this.user();
    const targetOrgId = parseInt(route.params['organisationId']);
    if (user && (user.role === UserRole.SUPER_ADMIN || (user.role === UserRole.ADMIN && targetOrgId === user.organisationId))) {
      return true;
    } else {
      this.router.navigate(['/main/knowledge-base']);
      return false;
    }
  }
}
